import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'

// Import Utils
import { makeImgResizerUrl } from '@jelly/utils'

// Import Component
import { HoverPlusArrowWrapper, PlusWrapper } from '../HoverPlusArrow'

// Styled Component via Emotion
const CardWrapper = styled.div`
	background-size: cover;
	background-position: top;
	background-repeat: no-repeat;
	display: block;
	overflow: hidden;
	position: relative;
	width: 100%;
	${({ gridBrowserSupport }) => gridBrowserSupport};

	&.lazyloaded {
		background-image: url(${(props) => props.background});
	}

	&:hover {
		.overlayWrapper {
			margin-left: 0;
		}
		${PlusWrapper} {
			display: none;
		}
		${HoverPlusArrowWrapper} {
			display: block;
		}
	}
`
const OverlayWrapper = styled.span`
	background: ${({ theme }) => theme.colors.primary};
	color: ${({ theme }) => theme.colors.white};
	height: 100%;
	margin-left: -100%;
	max-width: 300px;
	position: absolute;
	transition: all 0.8s ease;
	width: 100%;
`
const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin: 0 auto;
	overflow-wrap: break-word;
	padding: 0;
	height: 100%;
	width: 85%;
`
const NameWrapper = styled.div`
	color: ${({ theme }) => theme.colors.secondary};
	font-size: 20px;
	margin-bottom: 15px;

	${({ theme }) => theme.MQ.XL} {
		font-size: 24px;
	}
`
const ContextWrapper = styled.div`
	color: ${({ theme }) => theme.colors.white};
	line-height: 20px;
	margin-bottom: 10px;
	font-weight: 400;
`
const Type = styled.div`
	${({ theme }) => theme.fonts.secondary};
	display: inline-block;
	font-size: 14px;
	font-weight: 600;

	${({ theme }) => theme.MQ.XL} {
		font-size: 16px;
	}
`

CardProfilePreview.propTypes = {
	background: string,
	company: string,
	gridBrowserSupport: string,
	industry: string,
	jobTitle: string,
	name: string,
}

/**
 * This Component is the Profile Preview Card
 * It sets an image as the background, hopefully a prpfile picture
 * The entire card is clickable and is a link
 * On Hover: a navy overflow slides in from the left with information on the profile
 */
export function CardProfilePreview({ background, company, gridBrowserSupport, industry, jobTitle, name }) {
	const backgroundUrl = makeImgResizerUrl({
		src: background,
		method: 'w',
		w: 300,
	})

	return (
		<CardWrapper alt={name} background={backgroundUrl} className="lazyload" gridBrowserSupport={gridBrowserSupport}>
			<OverlayWrapper className="overlayWrapper">
				<ContentWrapper>
					<NameWrapper>{name}</NameWrapper>
					<ContextWrapper>
						<Type>Expertise:</Type> {industry}
					</ContextWrapper>
					<ContextWrapper>
						<Type> Title: </Type> {jobTitle}
					</ContextWrapper>
					<ContextWrapper>
						<Type> Business Name: </Type> {company}
					</ContextWrapper>
				</ContentWrapper>
			</OverlayWrapper>
		</CardWrapper>
	)
}
